import { X } from "lucide-react";
import "../../styles/ContractManualTriggerPopup.css";
import { toast } from "react-toastify";
import axiosInstance from "../../axiosInstance";
import DatePicker from "react-datepicker";
import React, { useState, useEffect } from "react";
import "react-datepicker/dist/react-datepicker.css";

const ContractManualTriggerPopup = ({
    isOpen,
    data = [],
    contractId,
    onClose
}) => {
    const [selectedRows, setSelectedRows] = useState([]);
    const [supplyPeriods, setSupplyPeriods] = useState({});

    useEffect(() => {
        if (isOpen) {
            setSelectedRows([]);
            setSupplyPeriods({});
        }
    }, [isOpen]);

    if (!isOpen) return null;

    const handleRowSelect = (id) => {
        setSelectedRows((prev) =>
            prev.includes(id)
                ? prev.filter((rowId) => rowId !== id)
                : [...prev, id]
        );
    };

    const handleSelectAll = () => {
        if (selectedRows.length === data.length) {
            setSelectedRows([]);
        } else {
            const allIds = data.map((row) => row.job_type_id);
            setSelectedRows(allIds);
        }
    };

    const isAllSelected = selectedRows.length === data.length && data.length > 0;

    const handleSupplyChange = (jobTypeId, date) => {
        setSupplyPeriods((prev) => ({
            ...prev,
            [jobTypeId]: date
        }));
    };

    const formatSupplyPeriod = (date) => {
        if (!date) return null;

        const options = { month: "short", year: "numeric" };
        return new Date(date).toLocaleDateString("en-US", options).replace(" ", "-");
    };

    const handleConvert = async () => {
        if (selectedRows.length === 0) {
            toast.error("Please select at least one job type");
            return;
        }

        const jobs = selectedRows.map((id) => ({
            job_type_id: id,
            supply_period: formatSupplyPeriod(supplyPeriods[id])
        }));

        for (let job of jobs) {
            if (!job.supply_period) {
                const jobTypeName =
                    data.find(d => d.job_type_id === job.job_type_id)?.job_type || "Selected";

                toast.error(`Supply period is mandatory for ${jobTypeName} job type`);
                return;
            }
        }
        try {
            const response = await axiosInstance.post(
                `/contract/contractconversion/${contractId}`,
                { jobs }
            );

            const message = response?.data?.message || response?.data?.msg || "Contract successfully converted";
            toast.success(message);
            onClose();
        } catch (error) {
            console.error(error);
            const errorMessage = error?.response?.data?.message || error?.response?.data?.error || "Contract conversion failed";
            toast.error(errorMessage);
        }
    };

    return (
        <div className="contract-manual-trigger-popup-overlay">
            <div className="contract-manual-trigger-popup-container">

                <div className="contract-manual-trigger-popup-header">
                    <h2>Contract Manual Trigger</h2>

                    <div className="contract-manual-trigger-header-right">
                        <div className="merged-close-btn" onClick={onClose}>
                            <X size={16} />
                        </div>
                    </div>
                </div>

                <div className="contract-manual-trigger-popup-body">
                    {/* Select All Row */}
                    <div className="contract-manual-trigger-popup-checkbox">
                        <label className="glass-checkbox">
                            <input
                                type="checkbox"
                                checked={isAllSelected}
                                onChange={handleSelectAll}
                            />
                            <span>✓</span>
                        </label>

                        <span className="cmt-selection-label">
                            {selectedRows.length} selected of {data.length} records
                        </span>
                    </div>

                    <div className="contract-manual-trigger-card-section">
                        {data.map((record, index) => (
                            <div className="contract-manual-trigger-card"
                                key={index}  >

                                {/* Checkbox */}
                                <div className="cmt-checkbox-checked">
                                    <div className="cmt-checkbox-checked">
                                        <label className="glass-checkbox">
                                            <input
                                                type="checkbox"
                                                checked={selectedRows.includes(record.job_type_id)}
                                                onChange={() => handleRowSelect(record.job_type_id)}
                                            />
                                            <span>✓</span>
                                        </label>
                                    </div>
                                </div>

                                {/* Job Type */}
                                <div className="contract-manual-trigger-left-block">
                                    <p className="label job-type-label">
                                        Job Type
                                    </p>
                                    <p className="contract-manual-trigger-title">
                                        {record.job_type}
                                    </p>
                                </div>

                                <div className="separate-divider"></div>



                                {/* Sales Net */}
                                <div className="contract-manual-trigger-info-box rate">
                                    <p className="label sales-label">
                                        Sales Net Total
                                    </p>

                                    <p className="value">
                                        {record.sales_net_total}
                                    </p>
                                </div>

                                {/* Cost Net */}
                                <div className="contract-manual-trigger-info-box net-total">
                                    <p className="label cost-label">
                                        Cost Net Total
                                    </p>
                                    <p className="value net-total-value">
                                        {record.cost_net_total}
                                    </p>
                                </div>

                                {/* Supply Period */}
                                <div className="contract-manual-trigger-info-box supply">
                                    <p className="label supply-label">
                                        Supply Period
                                    </p>
                                    <p className="value">
                                        <DatePicker
                                            selected={supplyPeriods[record.job_type_id] || null}
                                            onChange={(date) =>
                                                handleSupplyChange(record.job_type_id, date)
                                            }
                                            dateFormat="MMM-yyyy"
                                            showMonthYearPicker
                                            placeholderText="MMM-YYYY"
                                            className="supply-period-datepicker"
                                        />
                                    </p>
                                </div>

                            </div>

                        ))}
                    </div>

                    <div className="contract-manual-trigger-popup-footer">
                        <button
                            className="contract-manual-trigger-btn contract-cancel-btn"
                            onClick={onClose} >
                            Cancel
                        </button>

                        <button
                            className="contract-manual-trigger-btn contract-submit-btn"
                            onClick={handleConvert}   >
                            Convert
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ContractManualTriggerPopup;